import { createContext, useContext } from "react";
import GameStore from "./gameStore";
import CommonStore from "./commonStore";
import UserStore from "./userStore";
import ModalStore from "./modalStore";
import ProfileStore from "./profileStore";
import CommentStore from "./commentStore";
import CompanyStore from "./companyStore";
import CompanySportVenueStore from "./companySportVenueStore";
import CompanySportVenueAssetStore from "./companySportVenueAssetStore";
import CalendarStore from "./calendarStore";
import FriendStore from "./friendStore";
import FriendRequestStore from "./friendRequestStore";
import FriendListStore from "./friendListStore";
import MessageStore from "./messageStore";
import UserRatingStore from "./userRatingStore";
import NotificationStore from "./notificationStore";
import GameInvitationStore from "./gameInvitationStore";
import CourtStore from "./courtStore";
import GameVideoLinkStore from "./gameVideoLinkStore";
import ReportingStore from "./reportingStore";
import PlaygroundStore from "./playgroundStore";
import TeamStore from "./teamStore";
import TeamPostStore  from "./teamPostStore";
import TeamMatchStore  from "./teamMatchStore";
import TournamentStore from "./tournamentStore";

interface Store{
    gameStore: GameStore;
    commonStore:CommonStore;
    userStore:UserStore;
    modalStore:ModalStore;
    profileStore:ProfileStore;
    commentStore:CommentStore;
    companyStore:CompanyStore;
    companyVenueStore: CompanySportVenueStore;
    companySportVenueAssetStore:CompanySportVenueAssetStore;
    calendarStore:CalendarStore;
    friendStore: FriendStore;
    friendRequestStore: FriendRequestStore;
    friendListStore: FriendListStore;
    messageStore: MessageStore;
    userRatingStore:UserRatingStore;
    notificationStore: NotificationStore;
    gameInvitationStore: GameInvitationStore;
    courtStore: CourtStore;
    gameVideoLinkStore: GameVideoLinkStore;
    reportingStore: ReportingStore;
    playgroundStore:PlaygroundStore;
    teamStore:TeamStore;
    teamPostStore:  TeamPostStore;
    teamMatchStore:  TeamMatchStore;
    tournamentStore:TournamentStore;
}

export const store: Store = {

    gameStore: new GameStore(),
    commonStore: new CommonStore(),
    userStore: new UserStore(),
    modalStore: new ModalStore(),
    profileStore:new ProfileStore(),
    commentStore:new CommentStore(),
    companyStore:new CompanyStore(),
    companyVenueStore: new CompanySportVenueStore(),
    companySportVenueAssetStore:new CompanySportVenueAssetStore(),
    calendarStore: new CalendarStore(),
    friendStore: new FriendStore(),
    friendListStore: new FriendListStore(),
    friendRequestStore: new FriendRequestStore(),
    messageStore: new MessageStore(),
    userRatingStore: new UserRatingStore(),
    notificationStore: new NotificationStore(),
    gameInvitationStore :new GameInvitationStore(),
    courtStore: new CourtStore(),
    gameVideoLinkStore: new GameVideoLinkStore(),
    reportingStore: new ReportingStore(),
    playgroundStore:new PlaygroundStore(),
    teamStore:new TeamStore(),
    teamPostStore: new TeamPostStore(),
    teamMatchStore: new TeamMatchStore(),
    tournamentStore:new TournamentStore(),
}

export const StoreContext = createContext(store);

export function useStore(){
    return useContext(StoreContext);
}